import styled from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/Likes/LikesStep.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// LIKES STEP
// Reuses the --c-*/--sp-*/--r-sm/--t-fast custom properties that
// AssessmentStepShell.styles.js's <Section> scopes over the whole step —
// this file never redeclares them, same as FoodPreferencesStep.styles.js.
// ═══════════════════════════════════════════════════════════════════════════════

export const FieldGroup = styled.div`
  margin-bottom: var(--sp-6);
`;
FieldGroup.displayName = "FieldGroup";

export const FieldLabel = styled.label`
  display: block;
  color: var(--c-text);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: var(--sp-2);
`;
FieldLabel.displayName = "FieldLabel";

export const HelperValue = styled.span`
  color: var(--c-text-muted);
  font-weight: 500;
`;
HelperValue.displayName = "HelperValue";

// ─── Search input ────────────────────────────────────────────────────────────
export const SearchInput = styled.input.attrs({ type: "text" })`
  width: 100%;
  height: 44px;
  padding: 0 var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.92rem;
  border: 1px solid ${DIET_C.secondary}88;
  transition: border-color var(--t-fast);
  margin-bottom: var(--sp-3);

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }

  &::placeholder {
    color: var(--c-text-muted);
  }
`;
SearchInput.displayName = "SearchInput";

// ─── Active Screen 7 preferences hint ────────────────────────────────────────
// Shown under the search input whenever foodPreferences (Diet Type / Cuisine
// / Cooking Time / Budget from Screen 7) is influencing the suggestions.
export const FilterNote = styled.p`
  color: var(--c-text-muted);
  font-size: 0.8rem;
  font-style: italic;
  margin: calc(-1 * var(--sp-2)) 0 var(--sp-3);
`;
FilterNote.displayName = "FilterNote";

// ─── Search results — clickable suggestion chips ────────────────────────────
export const SuggestionGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin-bottom: var(--sp-4);
`;
SuggestionGrid.displayName = "SuggestionGrid";

export const SuggestionChip = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 9px 16px;
  border-radius: 999px;
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: 2.4px dashed ${DIET_C.secondary}66;
  transition: border-color var(--t-fast);

  &:hover:not(:disabled) {
    border-color: ${DIET_C.primary};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 3px solid var(--c-accent);
    outline-offset: 2px;
  }
`;
SuggestionChip.displayName = "SuggestionChip";

// ─── Selected values — removable chips ──────────────────────────────────────
export const SelectedGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  min-height: 40px;
`;
SelectedGrid.displayName = "SelectedGrid";

export const SelectedChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px 9px 16px;
  border-radius: 999px;
  background: ${DIET_C.primary}1a;
  color: var(--c-text);
  font-size: 0.88rem;
  font-weight: 600;
  border: 2.4px solid ${DIET_C.primary};
`;
SelectedChip.displayName = "SelectedChip";

export const RemoveChipButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: ${DIET_C.primary};
  font-size: 0.9rem;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: ${DIET_C.primary}33;
  }

  &:focus-visible {
    outline: 2px solid var(--c-accent);
    outline-offset: 1px;
  }
`;
RemoveChipButton.displayName = "RemoveChipButton";

export const EmptyState = styled.p`
  color: var(--c-text-muted);
  font-size: 0.85rem;
  margin: 0;
`;
EmptyState.displayName = "EmptyState";